<div class="container-full" style="margin-top:10px;">
    <div class="ace-heading-banner">
        <div style="padding-top:18px;">
            <span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">Generate Manual Invoices</span>
         </div>
    </div>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        </mat-card-header>    
        <mat-card-content>
        </mat-card-content>
    </mat-card>
</div>
